import {Dialog, DialogActions, DialogContent, DialogTitle} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import React from "react";
import {_delete, get} from '../../lib/axios'
import {connect} from "react-redux";

// [#136] 지식 그룹(부모 노드) 삭제 시 하위 지식까지 함께 지울지 선택하는 다이얼로그.
function DeleteGroup({is_open, selected_map_id, close, set, target}) {
    const handleDelete = (cascade) => {
        _delete(`/api/v1/seomalmap/${selected_map_id}/node/?node_id=${target}&cascade=${cascade}`, {}, (result) => {
            close();
            get(`/api/v1/seomalmap/${selected_map_id}/`, {}, (json) => {
                set(json.data.elements, Number(selected_map_id), {read_public: json.data.read_public, write_public: json.data.write_public})
            });
        });
    };

    return (
        <Dialog open={is_open} onClose={close} style={{zIndex: 10000}}>
            <DialogTitle>무엇을 삭제할까요?</DialogTitle>
            <DialogContent style={{minWidth: '310px'}}>
            </DialogContent>
            <DialogActions style={{flexDirection: 'column', alignItems: 'stretch', padding: '8px 24px 16px'}}>
                <Button onClick={() => handleDelete(false)} color="primary" fullWidth style={{justifyContent: 'flex-start'}}>
                    그룹만 삭제 (안의 지식은 남겨두기)
                </Button>
                <Button onClick={() => handleDelete(true)} color="secondary" fullWidth style={{justifyContent: 'flex-start'}}>
                    그룹과 안에 있는 지식 모두 삭제
                </Button>
                <Button onClick={close} fullWidth style={{justifyContent: 'flex-start'}}>
                    취소
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default connect(
    (state) => {
        return {
            is_open: state.getIn(['ui', 'delete_group_is_open']),
            selected_map_id: state.getIn(['map', 'selected_map_id']),
            target: state.getIn(['ui', 'delete_group_target'])
        }
    },
    (dispatch) => {
        return {
            close: () => dispatch({type: 'CLOSE_DELETE_GROUP'}),
            set: (value, map_id, permission) => {
                dispatch({type: 'SET_MAP', value: value, selected_map_id: map_id, permission: permission})
            }
        }
    }
)(DeleteGroup)
